// src/contexts/sidebar.tsx
import { createContext, useContext, useState } from "react";
import { jsx } from "react/jsx-runtime";
var SidebarCollapseContext = createContext(void 0);
function useSidebarCollapse() {
  const ctx = useContext(SidebarCollapseContext);
  if (!ctx)
    throw new Error("Missing root provider");
  return ctx;
}
function SidebarCollapseProvider({
  children
}) {
  const [open, setOpen] = useState(true);
  return /* @__PURE__ */ jsx(SidebarCollapseContext.Provider, { value: [open, setOpen], children });
}

// src/contexts/search.tsx
import dynamic from "next/dynamic";
import { createContext as createContext2, useContext as useContext2, useEffect, useState as useState2 } from "react";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var DefaultSearchDialog = dynamic(
  () => import("./components/dialog/search-default.js")
);
var SearchContext = createContext2(void 0);
function useSearchContext() {
  const ctx = useContext2(SearchContext);
  if (!ctx)
    throw new Error("Missing root provider");
  return ctx;
}
function SearchProvider({
  SearchDialog,
  children,
  ...props
}) {
  const [isOpen, setIsOpen] = useState2();
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        setIsOpen(true);
        e.preventDefault();
      }
    };
    window.addEventListener("keydown", handler);
    return () => {
      window.removeEventListener("keydown", handler);
    };
  }, []);
  const Dialog = SearchDialog ?? DefaultSearchDialog;
  return /* @__PURE__ */ jsxs(SearchContext.Provider, { value: [setIsOpen], children: [
    isOpen !== void 0 && /* @__PURE__ */ jsx2(Dialog, { open: isOpen, onOpenChange: setIsOpen, ...props }),
    children
  ] });
}

export {
  useSidebarCollapse,
  SidebarCollapseProvider,
  useSearchContext,
  SearchProvider
};
